import { API_ROOT } from 'environment';

angular
  .module('app.views')
  .controller('ChangeSubscriptionFormController', function ($scope, $modalInstance, $http, $q, $routeParams, toaster, subscription) {
    $scope.$http = $http;
    $scope.$routeParams = $routeParams;
    $scope.toaster = toaster;
    $scope.subscription = subscription;
    $scope.loading = true;

    $http.get(`${API_ROOT}/checkout/free_trial_plans`).then((result) => {
      $scope.plans = result.data;
      // Use sane defaults for selected base plan and end date
      $scope.selectedPlan = $scope.plans[0].product_id;
      $scope.endDate = moment().add(14, 'days').toISOString();
      if (subscription) {
        $scope.initFromSub(subscription);
      }
      $scope.loading = false;
    }).catch((err) => {
      console.error(err);
      $scope.toaster.pop({
        type: 'error',
        body: `Error loading free trial options. Please try again.`,
        timeout: 2000
      });
      $scope.loading = false;
    });

    $scope.initFromSub = (sub) => {
      // Initialize selected base plan
      let items = (sub.items||[]);
      _.forEach(items, (item) => {
        let matchedPlan = _.find($scope.plans, p => p.product_id == item.product_id);
        if (matchedPlan) {
          $scope.selectedPlan = matchedPlan.product_id;
        }
      });
      $scope.endDate = moment(sub.period_end).toISOString();
    }

    $scope.onSelectPlan = (plan) => {
      $scope.selectedPlan = plan;
    }

    $scope.update = () => {
      $scope.isUpdating = true;
      if ($scope.loading) {
        return;
      }
      let endDate = moment($scope.endDate);
      $scope.$http.post(`${API_ROOT}/checkout/try`, {
        account_id: $scope.$routeParams.id,
        plan: $scope.selectedPlan,
        trial_end_date: endDate.toISOString(),
      }).success((data) => {
        $modalInstance.close(data);
      }).error((error) => {
        $scope.isUpdating = false;
        console.error(error);
        $scope.toaster.pop({
          type: 'error',
          body: `Error updating subscription. Please try again.`,
          timeout: 2000
        });
      });
    }

    return $scope.cancel = () => $modalInstance.dismiss('cancel');
  });



// WEBPACK FOOTER //
// ./views/account/change_subscription_form_controller.js